import { Box } from '@mui/material';

export default function KeepMountedTabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<Box variant="div" role="tabpanel" hidden={value !== index} id={`tabpanel-${index}`} aria-labelledby={`tab-${index}`} {...other}>
			<Box sx={{ display: value === index ? 'block' : 'none' }}>{children}</Box>
		</Box>
	);
}
